import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { SEO } from '@/lib/seoMeta';

/**
 * Renders route-specific <title>, <meta description>, and <link canonical>
 * via react-helmet-async. Place once in App.jsx — it reads the current route
 * automatically.
 */
export default function PageMeta() {
  const { pathname } = useLocation();
  const meta = SEO[pathname];
  if (!meta) return null;

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={meta.canonical} />
      {meta.robots && <meta name="robots" content={meta.robots} />}
    </Helmet>
  );
}
